export default {
  disclaimer: '免责声明',
  privacy_policy_statement: '私隐与政策',
  security_information: '保安资讯',
  risk_disclosure_statement: '风险披露声明',
  telephone: '咨询电话'
}
